import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import 'moment/locale/es';
import { Patient } from '../../interfaces/Patients';
import { NotaEnfermeria } from '../../interfaces/NotaEnfermeria';
import { Nurse } from '../../interfaces/Nurses';
import {
  formatDate,
  getDoctorFullName,
  getNurseFullName,
  getPatientFullName,
} from '../../utils/fns';
import { useMainProvider } from '../../context/MainProvider';
import { UserTypes } from '../../interfaces/User';
import { Doctor } from '../../interfaces/Doctors';

function NotaEnfermeriaDocument({
  patient,
  nurse,
  values,
}: {
  patient: Patient;
  nurse: Nurse;
  values: NotaEnfermeria;
}): JSX.Element {
  const { user } = useMainProvider();
  const [name, setName] = useState('');

  useEffect(() => {
    if (user && user.initialData) {
      if (user.typeId === UserTypes.PatientType) {
        setName(getPatientFullName(user.initialData as Patient).toUpperCase());
      }
      if (user.typeId === UserTypes.DoctorType) {
        setName(getDoctorFullName(user.initialData as Doctor).toUpperCase());
      }
      if (user.typeId === UserTypes.NurseType) {
        setName(getNurseFullName(user.initialData as Nurse).toUpperCase());
      }
    }
  }, [user]);

  useEffect(() => {
    moment.locale('es');
  }, [patient]);

  return (
    <table className='table-full-width'>
      <tbody>
        <tr>
          <td>
            <table className='table-full-width'>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <p style={{ textAlign: 'end' }}>
                        <strong>
                          Fecha y Hora de impresión:{' '}
                          {moment().locale('ES').format('DD MMMM YYYY h:mm:ss a')}
                          <br />
                        </strong>
                      </p>
                      <p style={{ textAlign: 'right' }}>
                        <strong>
                          {nurse.enf_consultorio?.toUpperCase()}
                          <br />
                          {nurse.enf_no_registro?.toUpperCase()}
                          <br />
                          {nurse.enf_domicilio?.toUpperCase()},
                          {nurse.enf_colonia_consultorio?.toUpperCase()},{' '}
                          {nurse.enf_municipio_consultorio?.toUpperCase()},{' '}
                          {nurse.enf_ciudad_consultorio?.toUpperCase()},
                          {nurse.enf_cp_consultorio}
                          <br />
                          Tel. {nurse.enf_telefono_consultorio}
                        </strong>
                      </p>
                      <br />
                      <p style={{ textAlign: 'center', marginBottom: '50px' }}>
                        <strong>Nota De Enfermería.</strong>
                      </p>
                      <p style={{ textAlign: 'start' }}>
                        <strong>
                          Fecha y Hora de elaboración de la Nota:{' '}
                          {moment(values.fecha_creacion)
                            .locale('ES')
                            .format('DD MMMM YYYY h:mm:ss a')}
                        </strong>
                      </p>
                      <p style={{ textAlign: 'start' }}>
                        <strong>
                          Datos del paciente
                          <br />
                        </strong>
                      </p>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Nombre</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {patient.pac_nombre} {patient.pac_apellidop}{' '}
                            {patient.pac_apellidom}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Fecha de nacimiento</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {moment(patient.pac_fechanacimiento)
                              .locale('ES')
                              .format('DD/MM/YYYY')}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Edad</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {moment().diff(patient.pac_fechanacimiento, 'years')} años
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Sexo</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {patient.pac_sexo?.cat_sexo_desc}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Curp</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'uppercase' }}>
                            {patient.pac_curp}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>Expediente</div>

                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {patient.pac_id}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Grupo Sanguíneo</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {patient.pac_tipo_sangre}
                          </span>
                        </div>
                      </div>
                      <p style={{ textAlign: 'start' }}>
                        <strong>
                          Datos de la nota
                          <br />
                        </strong>
                      </p>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Fecha y hora</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {moment(values.fecha_creacion)
                              .locale('ES')
                              .format('DD MMMM YYYY h:mm:ss a')}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Peso</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.peso}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Altura</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.altura}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Presión arterial</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.presion_arterial}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Frecuencia cardiaca</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.frecuencia_cardiaca}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Frecuencia respiratoria</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.frecuencia_respiratoria}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Temperatura</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.temperatura}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Oxigenación</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.oxigenacion}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Subjetivos</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.comentarios_subjetivos}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Objetivos</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.comentarios_objetivos}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Análisis</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.analisis}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Pronóstico</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.pronostico}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'>
                          {' '}
                          Diagnostico(s) presuntivo(s)
                        </div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.nota_enfermeria_diagnosticos?.map((singleDiag) => {
                              return (
                                <p style={{ margin: '0', marginBottom: '15px' }}>
                                  - {singleDiag.cie_clave} {singleDiag.cie_descripcion}
                                </p>
                              );
                            })}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Plan de trabajo</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.plan_trabajo}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Alergias a medicamentos</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.nota_enfermeria_alergias}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Alergias alimentos</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.alergias_alimentos}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Otras alergias</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.alergias_otros}
                          </span>
                        </div>
                      </div>

                      <div>
                        <p style={{ textAlign: 'start' }}>
                          <strong>
                            Indicaciones del Médico Tratante
                            <br />
                          </strong>
                        </p>
                      </div>

                      <div className='print-data-container'>
                        <div className='print-data-left'> Dieta</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.dieta}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Soluciones</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.soluciones}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Medicamentos</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.medicamentos_seleccionados?.map((singleMedicine) => {
                              return (
                                <div style={{ margin: '0', marginBottom: '15px' }}>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    - {singleMedicine.medicamento?.sales}
                                  </p>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    Nombre patente recomendado:{' '}
                                    <strong>{singleMedicine.marca_recomendada}</strong>
                                  </p>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    Dosis: {singleMedicine.dosis}
                                  </p>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    Periodicidad: {singleMedicine.periodicidad}
                                  </p>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    Días: {singleMedicine.numero_dias}
                                  </p>
                                  <p style={{ margin: '0', marginBottom: '3px' }}>
                                    No. Cajas: {singleMedicine.numero_cajas}
                                  </p>
                                </div>
                              );
                            })}
                          </span>
                        </div>
                      </div>
                      {values.medicamentos_fuera_cuadro ? (
                        <div className='print-data-container'>
                          <div className='print-data-left'>
                            {' '}
                            Medicamentos fuera del cuadro básico
                          </div>
                          <div className='print-data-right'>
                            <span style={{ textTransform: 'capitalize' }}>
                              {values.medicamentos_fuera_cuadro}
                            </span>
                          </div>
                        </div>
                      ) : null}
                      <div className='print-data-container'>
                        <div className='print-data-left'> Estudios indicados</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.estudios_indicados}
                          </span>
                        </div>
                      </div>
                      <div className='print-data-container'>
                        <div className='print-data-left'> Otras indicaciones</div>
                        <div className='print-data-right'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {values.otras_indicaciones}
                          </span>
                        </div>
                      </div>
                      <p style={{ textAlign: 'start' }}>
                        <strong>
                          Datos de la enfermera
                          <br />
                        </strong>
                      </p>
                    </span>

                    <div className='print-data-container'>
                      <div className='print-data-left'>Nombre</div>

                      <div className='print-data-right'>
                        <span style={{ textTransform: 'capitalize' }}>
                          {nurse.enf_nombre} {nurse.enf_apellidop} {nurse.enf_apellidop}
                        </span>
                      </div>
                    </div>

                    <div className='print-data-container'>
                      <div className='print-data-left'>Especialidad</div>

                      <div className='print-data-right'>
                        <span style={{ textTransform: 'capitalize' }}>
                          {nurse.enf_especialidad?.cat_especialidad_desc}
                        </span>
                      </div>
                    </div>

                    <div className='print-data-container'>
                      <div className='print-data-left'>Cédula</div>

                      <div className='print-data-right'>
                        <span style={{ textTransform: 'capitalize' }}>
                          {nurse.enf_cedula_profesional}
                        </span>
                      </div>
                    </div>

                    {nurse.enf_especialidad_id !== 15 ? (
                      <>
                        <div className='print-data-container'>
                          <div className='print-data-left'>Cédula especialidad</div>

                          <div className='print-data-right'>
                            <span style={{ textTransform: 'capitalize' }}>
                              {nurse.enf_cedula_especialidad}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : null}

                    <p style={{ textAlign: 'start' }}>
                      <strong>
                        Aviso de privacidad
                        <br />
                      </strong>
                    </p>
                    <p style={{ fontSize: '0.8rem' }}>
                      Para ver nuestro Aviso de privacidad favor consultar:
                      http://zivot.com.mx/aviso-privacidad
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default NotaEnfermeriaDocument;
